enum BoxType {
    Undefined = 0,
    Rectangular = 1,
    LShape = 2,
    UShape = 3,
    Custom = 4,
    FloorPlanner = 9
}

export default BoxType;